import Slides from './Slides.js';

import img1 from './images/portfolio/architectural/_IMG1199.jpg';
import img2 from './images/portfolio/architectural/_IMG7167.jpg';
import img3 from './images/portfolio/architectural/0022.jpg';
import img4 from './images/portfolio/architectural/0049.jpg';
import img5 from './images/portfolio/architectural/0085.jpg';
import img6 from './images/portfolio/architectural/023.jpg';
import img7 from './images/portfolio/architectural/024.jpg';
import img8 from './images/portfolio/architectural/0250.jpg';
import img9 from './images/portfolio/architectural/044.jpg';
import img10 from './images/portfolio/architectural/088.jpg';
import img11 from './images/portfolio/architectural/096.jpg';
import img12 from './images/portfolio/architectural/Broadway psoter.jpg';
import img13 from './images/portfolio/architectural/Clubhouse016.jpg';
import img14 from './images/portfolio/architectural/DSC_0018.jpg';
import img15 from './images/portfolio/architectural/DSC_0029.jpg';
import img16 from './images/portfolio/architectural/DSC_0058.jpg';
import img17 from './images/portfolio/architectural/Exteriors 029.jpg';
import img18 from './images/portfolio/architectural/Exteriors 042.jpg';
import img19 from './images/portfolio/architectural/Img 021.jpg';
import img20 from './images/portfolio/architectural/Img008.jpg';
import img21 from './images/portfolio/architectural/Img034.jpg';
import img22 from './images/portfolio/architectural/Img045.jpg';
import img23 from './images/portfolio/architectural/Img054.jpg';
import img24 from './images/portfolio/architectural/Lounge 005.jpg';
import img25 from './images/portfolio/architectural/Packard 04-14-04 001.jpg';
import img26 from './images/portfolio/architectural/YMCA-7-1-04-004.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
